import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import BrandSettings from "./BrandSettings";
import SwitchBrand from "./SwitchBrand";
import UserSettings from "./UserSettings";

class Profile extends Component {
  render() {
    const prefix = this.props.match.path;

    return (
      <Switch>
        <Route path={`${prefix}/switch-brand`} component={SwitchBrand} />
        <Route path={`${prefix}/user`} component={UserSettings} />
        <Route path={`${prefix}/brand`} component={BrandSettings} />
        <Redirect to="/404" />
      </Switch>
    );
  }
}

export default Profile;
